import React from 'react'
import Button from '../Button'

export default function Slide({title, children, className, style, button, onClick}) {
  
  return (
    
    <div className={`flex flex-col justify-between align-left m-3 ${className}`} style={style}>
      <div className="flex flex-col mb-2">
        {title && <h1 className="text-left text-primary text-xl font-semibold mb-2">{title}</h1>}
        {children && <div className={`${button && "mb-2"} text-left secondary font-sans text-gray-600`}>{children}</div>}
      </div>
      <div className="flex">
        {button && <Button className="w-auto" text={button} onClick={onClick}/>}
      </div> 
    </div>
      
  )
}
